/* eslint-disable react/no-array-index-key */
import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert, { AlertColor } from '@mui/material/Alert'
import { LogLevelEnum } from '@saas/interfaces/graphql'
import { hideSnackbar } from '../../actions/main'
import { useAppDispatch, useAppSelector } from '../../store'
import { useAddLogMutation } from '../../api/mutations/__generated__/addLog.gql'
import useCurrentHcs from '../../hooks/useCurrentHcs'
import useCurrentUser from '../../hooks/useCurrentUser'

export default function TokTokDocSnackbar() {
    const { open, severity, message, duration, loggerMessage } = useAppSelector((state) => state.main.snackbar)
    const [visible, setVisible] = React.useState(true)
    const dispatch = useAppDispatch()

    const currentHcs = useCurrentHcs()
    const currentUser = useCurrentUser()

    const [sendLog] = useAddLogMutation()

    const handleClose = () => {
        setVisible(false)
        dispatch(hideSnackbar())
    }

    React.useEffect(() => {
        setVisible(open)

        if (open && loggerMessage) {
            sendLog({
                variables: {
                    input: {
                        hcsId: currentHcs.objectId,
                        fromApp: 'IDS',
                        userId: currentUser?.objectId ?? '',
                        message: loggerMessage,
                        logLevel: logLevel(severity),
                    },
                },
            })
        }

    }, [open])

    const logLevel = (value: string): LogLevelEnum => {
        if (value === 'error') return 'ERROR'
        if (value === 'warning') return 'WARN'
        return 'INFO'
    }

    const renderMessage = () => {
        if (message) {
            if (typeof message === 'string') return message
            if (Array.isArray(message)) {
                return (
                    <ul>
                        {message.map((m, i) => (
                            <li key={i}>{m}</li>
                        ))}
                    </ul>
                )
            }
            return null
        }

        return null
    }

    if (!message) return null

    return (
        <div
            style={{
                opacity: visible ? 1 : 0,
            }}
        >
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={open}
                autoHideDuration={duration}
                onClose={handleClose}
            >
                <MuiAlert
                    data-cy="commonSnackbarMessage"
                    severity={severity as AlertColor}
                    variant="filled"
                    onClose={handleClose}
                >
                    {renderMessage()}
                </MuiAlert>
            </Snackbar>
        </div>
    )
}
